import EventEmitter from "../../../node_modules/eventemitter3/index";
import {
  EmailTemplateClient,
  PlantillaCorreo,
  Stage,
  StagesClient,
  Transition,
  TransitionsClient,
} from "../client/Client";
import EventList from "../Events/EventList";
import { UsuariosInternosService } from "../Services/UsuariosInternosService";
import Store from "../Store";

import {
  addDefaultOptionsToSelectElement,
  addOptionsToSelect,
  addOptionsToSelectBySelector,
  createOptions,
} from "../Utilities/Select";
const SIN_ESTRATEGIA = "0";
let $plantillaFormularId = <HTMLSelectElement>document.querySelector("#plantillaId");

export default class TransitionComponent {
  stages: Stage[];
  $from = <HTMLSelectElement>document.getElementById("from");
  $to = <HTMLSelectElement>document.getElementById("to");
  $transitionType = <HTMLSelectElement>(
    document.getElementById("transition-type")
  );
  $emailTemplate = <HTMLSelectElement>document.getElementById("email-template");
  $description = <HTMLInputElement>document.getElementById("description");
  $transitionForm = <HTMLFormElement>(
    document.querySelector("#transition-main-form")
  );
  $editControls = <HTMLDivElement>(
    document.querySelector("#transition-edit-controls")
  );
  $addTransitionBtn = <HTMLButtonElement>(
    document.querySelector("#add-transition-btn")
  );
  $transitionId = <HTMLInputElement>document.querySelector("#transition-id");
  $isAutomatic = <HTMLSelectElement>document.querySelector("#is-automatic");
  $allowFiles = <HTMLSelectElement>document.querySelector("#allow-files");

  

  selectedTransition: Transition;
  /**
   *
   */
  constructor(
    private stagesClient: StagesClient,
    private eventEmitter: EventEmitter,
    private store: Store,
    private transitionClient: TransitionsClient,
    private emailTemplateClient: EmailTemplateClient
  ) {
    this.eventEmitter.on(EventList.STAGES_FETCHED, this.setStages);
    this.FetchStages();
    this.eventEmitter.on(EventList.STAGE_CREATED, this.addStageToLists);
    this.eventEmitter.on(EventList.STAGE_DELETED, this.removeStage);
    this.eventEmitter.on(EventList.STAGE_UPDATED, this.updateStageInLists);
    this.eventEmitter.on(
      EventList.TRANSITION_SELECTED,
      this.transitionSelectedHandler
    );
    this.eventEmitter.on(EventList.PLANTILLA_ID_CHANGED, this.FetchStages)
    this.$transitionForm.onsubmit = this.transitionSubmitHandler;
    this.$transitionForm.onreset = this.formResetHandler;
    this.emailTemplateClient.get().then(this.loadEmailTemplateSelect);
  }
  
  FetchStages= ()=> {
    this.stagesClient
      .getParaPlantilla(parseInt($plantillaFormularId.value))
      .then((stages: Stage[]) =>
        this.eventEmitter.emit(EventList.STAGES_FETCHED, stages)
      )
      .catch((e) => {
        console.log(e);
        Alerta.SwalError("Error al obtener listado de Etapas");
      });
  }

  formResetHandler = () => {
    this.$editControls.style.display = "none";
    this.$addTransitionBtn.style.display = "";
  };

  transitionSelectedHandler = (transition: Transition) => {
    this.$description.value = transition.description;
    this.$to.value = transition.toId.toString();
    this.$from.value = transition.fromId.toString();
    this.$emailTemplate.value =
      transition.plantillaCorreoId?.toString() ?? "seleccionar";
    this.$transitionType.value = transition.tipoTransicion.toString();
    this.$transitionId.value = transition.id.toString();

    this.$editControls.style.display = "inline-block";
    this.$addTransitionBtn.style.display = "none";

    this.selectedTransition = transition;
    this.$isAutomatic.value = transition.isAutomatic? "true": "false";
    this.$allowFiles.value = transition.allowFiles? "true": "false";
    //i
  };

  updateTransition = async (transition: Transition) => {
    try {
      let newTransition = await this.transitionClient.put(transition.id, transition);
      Notify.success("Transición actualizada");
      this.eventEmitter.emit(EventList.TRANSITION_UPDATED, newTransition);

      this.$transitionForm.reset();
      this.$editControls.style.display = "none";
      this.$addTransitionBtn.style.display = "";
    } catch (ex) {
      Notify.handleApiError(ex);
    }
  };

  loadEmailTemplateSelect = (emailTemplate: PlantillaCorreo[]) => {
    let options = createOptions(
      emailTemplate,
      (e) => e.id.toString(),
      (e) => e.nombre
    );
    addOptionsToSelect(this.$emailTemplate, options);
  };

  transitionSubmitHandler = async (evt: Event) => {
    evt.preventDefault();

    let transition = new Transition();
    transition.id = parseInt(this.$transitionId.value);
    transition.fromId = parseInt(this.$from.value);
    transition.toId = parseInt(this.$to.value);
    transition.description = this.$description.value;
    transition.isAutomatic = this.$isAutomatic.value == "true";
    transition.allowFiles = this.$allowFiles.value == "true";

    transition = Object.assign({}, this.selectedTransition, transition);

    let emailTemplateid = Number(this.$emailTemplate.value);
    if (isNaN(emailTemplateid)) {
      transition.plantillaCorreoId = null;
    } else {
      transition.plantillaCorreoId = emailTemplateid;
    }

    transition.tipoTransicion = parseInt(this.$transitionType.value);

    if (transition.description == "" || transition.description == null) {
      Alerta.SwalError("Debe ingresar descripción para la transición");
      return false;
    }

    if (transition.id == 0) {
      this.addTransition(transition);
    } else {
      this.updateTransition(transition);
    }

    return false;
  };

  addTransition = async (transition: Transition) => {
    try {
      let newTransition = await this.transitionClient.post(transition);
      this.eventEmitter.emit(EventList.TRANSITION_CREATED, newTransition);
      Notify.success("Transición agreagada");
      this.$transitionForm.reset();
    } catch (ex) {
      Notify.handleApiError(ex);
    }
  };

  removeStage = (stageId: number) => {
    this.stages = this.stages.filter((e) => e.id != stageId);
    this.removeStageFromSelect(this.$to, stageId);
    this.removeStageFromSelect(this.$from, stageId);
  };

  editStage = (stage: Stage) => {
    this.stages = this.stages.filter((e) => e.id != stage.id);
    this.stages = [...this.stages, stage];
    this.updateStageInSelect(this.$to, stage);
    this.updateStageInSelect(this.$from, stage);
  };

  updateStageInSelect = (select: HTMLSelectElement, stage: Stage) => {
    let op = Array.from(select.options).find(
      (op) => op.value == stage.id.toString()
    );
    if (op) {
      op.textContent = stage.name;
    }
  };

  removeStageFromSelect = (select: HTMLSelectElement, id: number) => {
    let index = Array.from(select.options)
      .map((e) => e.value)
      .indexOf(id.toString());
    if (index > -1) select.options.remove(index);
  };

  addStageToLists = (stage: Stage) => {
    this.stages.push(stage);
    this.addStageToSelect(this.$to, stage);
    if (!stage.isFinal) this.addStageToSelect(this.$from, stage);
  };

  updateStageInLists = (stage: Stage) => {
    this.stages = [...this.stages.filter((e) => e.id != stage.id), stage];
    this.$from.textContent = '';
    this.$to.textContent = '';
    this.setStages(this.stages);
  };

  addStageToSelect = (select: HTMLSelectElement, stage: Stage) => {
    let option = document.createElement("option");
    option.value = stage.id.toString();
    option.text = stage.name;
    select.options.add(option);
  };

  setStages = (stages: Stage[]) => {
    this.stages = stages;
    this.$from.textContent = '';
    this.$to.textContent = '';
    addOptionsToSelectBySelector(
      "#from",
      this.stages.filter((e) => !e.isFinal),
      (e) => e.id.toString(),
      (e) => e.name
    );
    addOptionsToSelectBySelector(
      "#to",
      this.stages,
      (e) => e.id.toString(),
      (e) => e.name
    );
  };
}
